import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';
import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable,  throwError, of, BehaviorSubject } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { MessageService } from 'primeng/api';

//import { ObservableStore } from '@codewithdan/observable-store';
//import { MasterDataSurveyStoreState, MasterDataSurveyActions } from '../../common/store/store-states';


//const headers = new HttpHeaders().set("Content-Type", "application/json",).set("Ocp-Apim-Subscription-Key",environment.Ocp_Apim_Subscription_Key).set("Ocp-Apim-Trace",environment.Ocp_Apim_Trace);

@Injectable(
    {
        providedIn: 'root', // Asegura que el servicio sea singleton
    }
)
export class DataService {

  private _encuestaSeleccionada = new BehaviorSubject<string | null>(sessionStorage.getItem('encuestaSeleccionada'));
  encuestaSeleccionada$ = this._encuestaSeleccionada.asObservable();
  loginDisplay = false;

  setEncuestaSeleccionada(valor: string) {
    sessionStorage.setItem('opcionSeleccionada', valor);
    this._encuestaSeleccionada.next(valor); // Notifica a los suscriptores
  }

  getEncuestaSeleccionada(): string | null {
    return sessionStorage.getItem('encuestaSeleccionada');
  }

    checkLoginStatus(): boolean {
        
        if (sessionStorage.getItem('token') != null) {
            return true;
        }
        else {
            return false;
        }
    }


    cambiarEstadoUsuario() { 
        
        if (sessionStorage.getItem('token') != null) {
            //extraer el nombre del usuario del token
            var token = sessionStorage.getItem('token');
            this.usuario= jwtDecode(token);
            //alert("Bienvenido "+ JSON.stringify(this.usuario));

            this.usuarioAutenticado.next(true);           
        }
        else {
            this.usuarioAutenticado.next(false);            
        }
    }

    private usuarioAutenticado = new BehaviorSubject<boolean>(this.checkLoginStatus());
    usuarioAutenticado$ = this.usuarioAutenticado.asObservable();

    httpOptions = {  headers: new HttpHeaders({ 'Authorization': 'Bearer '+ sessionStorage.getItem('token'), 'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*','Access-Control-Allow-Headers': '*','cache-control': 'no-cache'}).set("Ocp-Apim-Subscription-Key","1").set("Ocp-Apim-Trace","1")}; 

    usuario:any;    
    rutaAPI: string = `${environment.API_URL}`;
    APIDirecta: string = this.rutaAPI;
    get Claims(): any[] {
        return JSON.parse(sessionStorage.getItem('Claims') || '[]');
      }
      set Claims(value: any[]) {
        sessionStorage.setItem('Claims', JSON.stringify(value));
      }
    
      get Token(): string {
        return sessionStorage.getItem('Token') || '';
      }
      set Token(value: string) {
        sessionStorage.setItem('Token', value);
      }



    constructor(private http: HttpClient, private router: Router, private messageService: MessageService) {
        //super({ stateSliceSelector: (state) => { return { Zonas: state !== null ? state.Zonas : [], } } });       

    }

    private formatErrors(error: any) {
        return  throwError(error);
    }

    GuardarRegistro(registro): Observable<any> {
      return this.http.post(this.rutaAPI+"Portal_GuardarRegistro", registro, this.httpOptions).pipe(catchError(this.formatErrors));
    }

    EnviarDiligenciado(registro): Observable<any> {
      console.log("Guardando Registro");
      return this.http.post(this.rutaAPI+"Portal_EnviarDiligenciado", registro, this.httpOptions).pipe(catchError(this.formatErrors));
    }

        GuardarFormulario(id, definicion, agregarsujeto, campoidentificador, campodescripcion): Observable<any> {
          //
          //return this.http.post(`${environment.base_url}` +"/Sincronizador/obtenerformulario", '192', httpOptions).pipe(catchError(this.formatErrors));
          var formularioOBJ = JSON.parse(definicion);
  
          var datosaenviar =
          {
            Definicion : formularioOBJ,
            Estado: 'activo'
          }



          if (id != null) {
            datosaenviar['_id'] = id;
          }
          if (agregarsujeto != null) {
            datosaenviar['AgregarSujeto'] = agregarsujeto;
          }
          if (campoidentificador != null) {
            datosaenviar['CampoIdentificador'] = campoidentificador;
          }
          if (campodescripcion != null) {
            datosaenviar['CampoDescripcion'] = campodescripcion;
          }
        console.log("===================================== datosaenviar =====================================");
        console.log("===================================== datosaenviar =====================================");
        console.log("===================================== datosaenviar =====================================");
        console.log("===================================== datosaenviar =====================================");
        console.log("===================================== datosaenviar =====================================");
        console.log("===================================== datosaenviar =====================================");
          console.log(JSON.stringify(datosaenviar));
  
          return this.http.post(this.rutaAPI+"Portal_GuardarFormulario", JSON.stringify(datosaenviar), this.httpOptions).pipe(catchError(this.formatErrors));
          
      }

      ObtenerFormulario(id): Observable<any> {
        return this.http.post(this.rutaAPI+"Portal_ObtenerFormulario", JSON.stringify({'id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      ObtenerFormularioPublico(id): Observable<any> {
        return this.http.post(this.rutaAPI+"Portal_ObtenerFormularioPublico", JSON.stringify({'id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      ObtenerFormularios(): Observable<any> {
        this.prepararSolicitud();
        return this.http.post(this.rutaAPI+"Portal_ObtenerFormularios",'', this.httpOptions).pipe(catchError(this.formatErrors));

      }

      ObtenerEstrategias(): Observable<any> {
        this.prepararSolicitud();
        return this.http.post(this.rutaAPI+"Portal_Obtenerestrategias",'', this.httpOptions).pipe(catchError(this.formatErrors));

      }

      ObtenerEncuestas(id): Observable<any> {
        return this.http.post(this.rutaAPI+"Portal_ObtenerEncuestas", JSON.stringify({'id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      ObtenerUsuarios(IdEncuesta): Observable<any> {
        return this.http.post(this.rutaAPI+"Portal_ObtenerUsuariosXEncuesta", JSON.stringify({'id': IdEncuesta}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      ObtenerProyecto(id, columnas, pagina, tampag, saltar): Observable<any> {

        var arrayColumnas = [];
        //recorrer columnas y asignar la propiedad value a cada una
        for (let columna of columnas) {
            arrayColumnas.push(columna);
        }
        return this.http.post(this.rutaAPI+"Portal_ObtenerProyecto", JSON.stringify({'id': id, 'campos':arrayColumnas, 'pagina':pagina, 'tampag':tampag, 'saltar':saltar}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      ObtenerRegistros(id, columnas, pagina, tampag, saltar, filtros: any[] = []): Observable<any> {

        var arrayColumnas = [];
        //recorrer columnas y asignar la propiedad value a cada una
        for (let columna of columnas) {
            arrayColumnas.push(columna);
        }
        return this.http.post(this.rutaAPI+"Portal_ObtenerRegistros", JSON.stringify({'id': id, 'campos':arrayColumnas, 'pagina':pagina, 'tampag':tampag, 'saltar':saltar, 'filtros': filtros}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      // Obtener solicitudes por promoción (POST con body)
      ObtenerSolicitudesPromociones(promocion: any, pagina: number, tampag: number, saltar: number): Observable<any> {
        const promocionNum = Number(promocion);
        const promocionPayload = isNaN(promocionNum) ? promocion : promocionNum;
        const payload = {
          promocion: promocionPayload,
          pagina,
          tampag,
          saltar
        };
        return this.http.post(
          this.rutaAPI + "Portal_ObtenerSolicitudes_promociones",
          JSON.stringify(payload),
          this.httpOptions
        ).pipe(catchError(this.formatErrors));
      }

      EliminarRegistro(IdRegistro): Observable<any> {
        return this.http.post(this.rutaAPI+"Portal_EliminarRegistro", JSON.stringify({'_id':IdRegistro}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      Login(user): Observable<any> {
        return this.http.post(this.rutaAPI+"Portal_Login", JSON.stringify(user), this.httpOptions).pipe(
          catchError(error => {
            this.messageService.add({severity:'error', summary: 'Error', detail: 'Error al iniciar sesión. Verifique sus credenciales.'});
            return this.formatErrors(error);
          })
        );
      }

      //implementar PreCrearClave usada en la creacion de contrasena
        PreCrearClave(id): Observable<any> {
            return this.http.post(this.rutaAPI+"Portal_PreCrearClave", JSON.stringify({'_id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
        }

        CrearClave(user): Observable<any> {
            return this.http.post(this.rutaAPI+"Portal_CrearClave", JSON.stringify(user), this.httpOptions).pipe(catchError(this.formatErrors));
        }

        ObtenerUsuario() {
            //decodificar el token de la variable de sesion "token"
            var token = sessionStorage.getItem('token');
            var tokenjson=null;
            if(token)
            {
              tokenjson = JSON.parse(atob(token?.split('.')[1]));
            }
            
            return tokenjson;
            
        }

        CrearEncuesta(encuesta): Observable<any> {
            return this.http.post(this.rutaAPI+"Portal_CrearEncuesta", JSON.stringify(encuesta), this.httpOptions).pipe(catchError(this.formatErrors));
        }

        CrearUsuario(usuarioencuesta): Observable<any> {
          return this.http.post(this.rutaAPI+"Portal_CrearUsuario", JSON.stringify(usuarioencuesta), this.httpOptions).pipe(catchError(this.formatErrors));
        }

        //editar encuesta
        EditarEncuesta(encuesta): Observable<any> {
            return this.http.post(this.rutaAPI+"Portal_CrearEncuesta", JSON.stringify(encuesta), this.httpOptions).pipe(catchError(this.formatErrors));
        }

          //editar usuario
          EditarUsuario(usuarioencuesta): Observable<any> {
            return this.http.post(this.rutaAPI+"Portal_EditarUsuario", JSON.stringify(usuarioencuesta), this.httpOptions).pipe(catchError(this.formatErrors));
        }

        //obtener registro
        ObtenerRegistro(id): Observable<any> {
            return this.http.post(this.rutaAPI+"Portal_ObtenerRegistro", JSON.stringify({'id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
        }

        //obtener solicitud
        ObtenerSolicitud(id): Observable<any> {
            return this.http.post(this.rutaAPI+"Portal_ObtenerSolicitud", JSON.stringify({'id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
        }

      ObtenerCampos(id): Observable<any> {
          return this.http.post(this.rutaAPI+"Portal_ObtenerCamposXEncuesta", JSON.stringify({'id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      // Obtener campos por promoción
      ObtenerCamposXPromocion(promocion: any): Observable<any> {
          const body = { promocion };
          console.log('Request ObtenerCamposXPromocion =>', body);
          return this.http.post(this.rutaAPI+"Portal_ObtenerCamposXPromocion", JSON.stringify(body), this.httpOptions).pipe(catchError(this.formatErrors));
      }

      // Obtener formulario asociado a una promoción específica
      ObtenerFormularioPorPromocion(promocion: number | string): Observable<any> {
        return this.http.post(
          this.rutaAPI + "Portal_ObtenerFormularios_promociones",
          JSON.stringify({ promocion }),
          this.httpOptions
        ).pipe(catchError(this.formatErrors));
      }

        ObtenerCamposXFormulario(id): Observable<any> {
          return this.http.post(this.rutaAPI+"Portal_ObtenerCamposXFormulario", JSON.stringify({'id': id}), this.httpOptions).pipe(catchError(this.formatErrors));
        }

        downloadExcelFile(fileName: string): void {
            const fileUrl = `assets/plantillas/${fileName}`;
            this.http.get(fileUrl, { responseType: 'blob' }).subscribe(blob => {
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            });
        }

    prepararSolicitud(){
        //obtener token de la sision
        var token = sessionStorage.getItem('token');
        //si no hay token, redirigir a la pagina de login
        if (token == null) {
            this.router.navigate(['/']);
        }
        else{
            this.httpOptions = {  headers: new HttpHeaders({ 'Authorization': 'Bearer '+ sessionStorage.getItem('token'), 'Content-Type': 'application/json',
                'Access-Control-Allow-Origin': '*','Access-Control-Allow-Headers': '*','cache-control': 'no-cache'}).set("Ocp-Apim-Subscription-Key","1").set("Ocp-Apim-Trace","1")}; 

        }
    }

    Precargue(idencuesta, respuestas, colecciones): Observable<any> {
      
      
        var registros = {
            idencuesta: idencuesta,
            respuestas: respuestas,
            colecciones: colecciones
        }
        console.log("===================================== registros =====================================");
        console.log(registros);

        return this.http.post(this.rutaAPI+"Portal_Precargue", JSON.stringify(registros), this.httpOptions).pipe(catchError(this.formatErrors));
    }

    
    downloadAndDisplayFileANT(ruta): void {  

        const httpOptions = {
          headers: new HttpHeaders({
            'Authorization': `Bearer ${sessionStorage.getItem('token')}`
          }),
          responseType: 'blob' as 'blob' // Asegura que el tipo de respuesta es Blob
        };

      this.http.get(this.rutaAPI+`Portal_Archivo?archivo=${ruta}`, httpOptions)
        .subscribe(blob => {
          console.log("Archivo descargado:", blob);

          // Crear un objeto URL para el Blob
          const objectURL = URL.createObjectURL(blob);
    
          // Crear un enlace <a> oculto
          const a = document.createElement('a');
          a.href = objectURL;
          a.download = ruta; // Nombre del archivo en la descarga
          document.body.appendChild(a);
          a.click(); // Simular el clic para descargar el archivo
          document.body.removeChild(a); // Remover el enlace
    
          // Liberar memoria
          URL.revokeObjectURL(objectURL);
        }, error => {
          console.error("Error al descargar el archivo:", error);
        });
    }

    downloadAndDisplayFile(ruta: string): Observable<Blob> {

      const url = `URL_DEL_SERVIDOR/${ruta}`;
      const httpOptions = {
        headers: new HttpHeaders({
          'Authorization': `Bearer ${sessionStorage.getItem('token')}`
        }),
        responseType: 'blob' as 'blob' // Asegura que el tipo de respuesta es Blob
      };

      return this.http.get(this.rutaAPI+`Portal_Archivo?archivo=${ruta}`, httpOptions).pipe(
        tap((blob: Blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = ruta.split('/').pop() || 'archivo';
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          document.body.removeChild(a);
        })
      );
    }



}
